import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import type { ApiError } from '@app/api/ApiError';
import { get, type ApiData } from '@app/api/typed';
import { readingInterval } from '@app/reading';

export type Overview = ApiData<'/api/v1/overview'>;
export type OverviewFailure = Overview['failures'][number];
export type FailureCard = OverviewFailure['card'];
export type FirstStep = Overview['first_steps'][number];

export const overviewKeys = {
  overview: ['overview'] as const,
};

/**
 * Visão geral (T3, FR-094). **Nunca** 502: os cards que dependem do middleware
 * degradam de forma independente em `falhas[]` (FR-095) — erro aqui só aparece
 * quando a própria leitura local falhou.
 *
 * Desde a foto do runtime (aim-6ph.13) esta é a leitura ÚNICA da tela: o estado
 * do cluster sai da foto guardada no Postgres, com o bloco `reading` de cada
 * bloco, e a rota responde na hora. Até 10/10/2026 havia o par `?source=cache` e
 * `live`, e a viva levava ~11 s no laboratório.
 */
export function useOverview(): UseQueryResult<Overview, ApiError> {
  return useQuery<Overview, ApiError>({
    queryKey: overviewKeys.overview,
    queryFn: () => get('/api/v1/overview'),
    // Primeira tela depois do login: envelhece rápido para refletir o tenant.
    staleTime: 15_000,
    // Os dois blocos que dependem do cluster têm cada um a sua foto (decisão 6): relê enquanto qualquer um deles
    // está sendo lido de novo.
    refetchInterval: (query) =>
      readingInterval(query.state.data?.readiness.reading, query.state.data?.connection.reading),
  });
}

// O **Discovery agora** saiu daqui em 29/08, quando a varredura passou a correr
// fora da requisição (`202` + acompanhamento). Disparo, polling, indicador, toast
// e invalidação viraram `@app/discovery` — a mesma peça para T3, T4, T21 e a
// moldura. Uma cópia por tela é como uma delas para de invalidar a lista de
// identidades e ninguém percebe por uma semana.
